export default __webpack_public_path__ + "static/media/Doc.b2bfadb3.svg";